import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
import { Icon, IconSize } from '../../icon';
import { is } from '../../../services';
import { Alignable } from '../../../objects';
/**
 * Tabs Item Component
 * @param active {boolean} active tab item
 * @param children {ReactChild} React Child Element
 * @param onClick onClick Event
 * @param to {string} Link
 * @param href {string} <a />
 * @param routerLink Custom Router Link as props
 * @param iconName {IconNameValues | IconName} add icon name
 * @param disabled {boolean} disable tab item
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 */
const TabsItem = ({ active = false, children, className, onClick, to, href, routerLink: RouterLink = 'a', iconName, disabled, testId, ...others }) => {
    const [isActived, setIsActived] = useState(active);
    const { styled } = useTrilogyContext();
    // accessibility
    const a11y = {
        a: {
            role: 'tab',
            'aria-selected': isActived,
            'data-tab-navigation': '',
        },
    };
    useEffect(() => {
        setIsActived(active);
    }, [active]);
    const classes = hashClass(styled, clsx('tab', disabled && is('disabled'), className, isActived && is('active')));
    const handleClick = (e) => {
        if (!disabled) {
            setIsActived(true);
            if (onClick) {
                onClick(e);
            }
        }
    };
    const LinkOrButton = to || href ? RouterLink : 'button';
    return (React.createElement(LinkOrButton, { className: classes, "data-testid": testId, ...a11y.a, href: href, to: to, ...others, onClick: handleClick },
        iconName && (React.createElement("div", { className: 'tab-icon' },
            React.createElement(Icon, { align: Alignable.ALIGNED_CENTER, size: IconSize.SMALL, name: iconName }))),
        children));
};
export default TabsItem;
//# sourceMappingURL=TabsItem.js.map